import { Stack } from '@mui/material';
import { EyeClosed, X } from 'lucide-react';
import DynamicTags from '../../../../../../../components/tags/DynamicTags/DynamicTags';
import { TagDynamicProps } from '../../../../../../../components/tags/DynamicTags/DynamicTags.types';
import LangEnum from '../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../translation/TranslationContext';
import { TranslateType } from '../../../../../../translation/translationContext.types';
import { useCatalogCardTagsStyles } from '../styles/catalogCardTags.styles';
import LiveDot, { LIVE_DOT_SIZE } from './LiveDot';
import { YoutubeIcon } from './YoutubeIcon';
import { CatalogCardTagType, CatalogCardTagsProps } from './types/catalogCardTags.types';

const catalogTags = (translate: TranslateType): Record<CatalogCardTagType, TagDynamicProps> => {
  return {
    [CatalogCardTagType.INACTIVE]: {
      id: CatalogCardTagType.INACTIVE,
      label: translate(LangEnum.GLOBAL_INACTIVE),
      iconProps: {
        icon: <EyeClosed size="16px" />,
        width: 16,
      },
    },
    [CatalogCardTagType.NOT_IN_VALIDITY_DATE]: {
      id: CatalogCardTagType.NOT_IN_VALIDITY_DATE,
      label: translate(LangEnum.GLOBAL_UNAVAILABLE),
      iconProps: {
        icon: <X size="16px" />,
        width: 16,
      },
    },
    [CatalogCardTagType.LIVE_SHOP_VIDEO]: {
      id: CatalogCardTagType.LIVE_SHOP_VIDEO,
      label: translate(LangEnum.GLOBAL_LIVE_SHOP),
      iconProps: {
        icon: <YoutubeIcon size={16} />,
        width: 16,
      },
    },
    [CatalogCardTagType.LIVE_SHOP_ON_AIR]: {
      id: CatalogCardTagType.LIVE_SHOP_ON_AIR,
      label: translate(LangEnum.GLOBAL_LIVE_SHOP),
      iconProps: {
        icon: <LiveDot />,
        width: LIVE_DOT_SIZE,
      },
    },
    [CatalogCardTagType.DYNAMIC]: {
      id: CatalogCardTagType.DYNAMIC,
      label: translate(LangEnum.CATALOGS_CATALOG_TYPE_DYNAMIC),
    },
  };
};

const CatalogCardTags = ({ tags }: CatalogCardTagsProps) => {
  const { translate } = useTranslation();
  const { classes } = useCatalogCardTagsStyles();
  const mountedTags = tags.map((tag) => catalogTags(translate)[tag]).filter(Boolean);

  return (
    <Stack className={classes.root}>
      <DynamicTags tags={mountedTags} variant="overlay" horizontalAlignment="right" />
    </Stack>
  );
};

export default CatalogCardTags;
